import classNames from 'classnames';
import {ComponentProps, PropsWithChildren} from 'react';

const InfoBox = (props: PropsWithChildren<ComponentProps<'div'>>) => {
  const {className, ...otherProps} = props;
  return (
    <div
      className={classNames(
        'flex rounded-2xl min-w-[3rem] border-normal border-primary-300 bg-primary-100 justify-center items-center p-sm',
        className
      )}
      {...otherProps}
    />
  );
};

export default InfoBox;
